import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SizedBox extends Vue { 
	@Prop() width!: string
	@Prop() height!: string
	@Prop() styleProp!: string
}
